import axios from '../../axios'

/**
 * 查询该机构的全部运动员
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const findPlayerByAgencyId = data => {
  return axios({
    url: '/match/matchPlayerServer/findPlayerByAgencyId/' + data.agencyId + '/' + data.pageNum + '/' + data.pageSize + '/' + (data.keyWords || -1) + '/' + (data.sex || -1),
    method: 'GET'
  })
}

/**
 * 1.6.1 查询班级学生列表
 * @param data
 */
export const queryClassStudent = data => {
  return axios({
    url: '/clubExamines/student/queryClassStudent/' + data.agencyId + '/' + data.dataId + '/' + (data.sex || -1) + '/' + (data.keyWords || -1) + '/' + data.pageType,
    method: 'GET'
  })
}



// WEBPACK FOOTER //
// ./src/http/modules/examines/studentList.js